import React, { useRef, useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import axios from "axios";
import carIocn from "../../assets/images/car.png";
import "swiper/css";
import "swiper/css/navigation";

import { MyApi } from "../../MyApi";
import tourImg from "../../assets/images/b3.jpg";

export default function PopularTours() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const [swiperReady, setSwiperReady] = useState(false);
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Attach swiper navigation refs
  useEffect(() => {
    if (prevRef.current && nextRef.current) {
      setSwiperReady(true);
    }
  }, []);

  // Fetch Top Picks Excursions
  useEffect(() => {
    const fetchTopPicks = async () => {
      try {
        const res = await axios.get(
          `${MyApi.BASE_URL}top-picks-excursions`,
          {
            headers: {
              Authorization: MyApi.SECRET_KEY,
            },
          }
        );

        if (res.data.status) {
          setTours(res.data.data || []);
        } else {
          setError(res.data.message || "No excursions found");
        }
      } catch (err) {
        console.error("API Error:", err);
        setError("Failed to load excursions");
      } finally {
        setLoading(false);
      }
    };

    fetchTopPicks();
  }, []);


  return (
    <div className="PopularTours pt-5">
      <Container className="position-relative">
       <div className="section-title mb-5">
            <img src={carIocn} alt="" />
            <h2>Top Routes We Serve</h2>
            <p>We Cover All Major Areas In Varanasi & Outstation Routes.</p>
          </div>

        {/* Custom arrows */}
        <div className="swiper-nav">
          <button className="swiper-btn prev-btn" ref={prevRef}>
            <svg viewBox="0 0 24 24">
              <path d="M15 18l-6-6 6-6" fill="none" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </button>

          <button className="swiper-btn next-btn" ref={nextRef}>
            <svg viewBox="0 0 24 24">
              <path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </button>
        </div>

       
        {loading && <p className="text-center py-5">Loading top picks...</p>}
        {error && <p className="text-center py-5">{error}</p>}

        {swiperReady && !loading && tours.length > 0 && (
          <Swiper
            modules={[Navigation, Autoplay]}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            spaceBetween={20}
            loop
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
            }}
            className="pToursSwiper"
          >
            {tours.map(({ product, parent_category }) => (
              <SwiperSlide key={product.id}>
                <div className="toursList">
                  <div className="tour_img">
                    <Link
                      to={`/${parent_category.categoryurl}/${product.producturl}`}
                    >
                      <img
                        src={product.image_url || tourImg}
                        alt={product.productname}
                        className="img-fluid"
                      />
                    </Link>
                  </div>
                  <h4 className="mt-3">{product.productname}</h4>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </Container>
    </div>
  );
}
